module.exports = __webpack_public_path__ + "static/media/astronomy_01.b9d3d16f.jpg";